import { Injectable, inject } from '@angular/core';
import { UrlTree } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as refValSheetActions from '../store/reference-value-sheet.actions';

@Injectable({
  providedIn: 'root',
})
export class ReferenceValueSheetGuard {
  private store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  // Set initial state for the base when navigating away from create component
  canDeactivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.store.dispatch(
      refValSheetActions.setBaseRefValSheetRequest({
        refValSheet: null,
      }),
    );

    return true;
  }
}
